var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.18C2 19.83 4.17 22 7.81 22H16.18C19.82 22 21.99 19.83 21.99 16.19V7.81C22 4.17 19.83 2 16.19 2Z",
    fill: "#F37846"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8496 13.5301C17.7696 13.3501 17.6296 13.2001 17.4396 13.1201C17.3496 13.0801 17.2496 13.0601 17.1496 13.0601H6.84961C6.43961 13.0601 6.09961 13.4001 6.09961 13.8101C6.09961 14.2201 6.43961 14.5601 6.84961 14.5601H15.3496L13.5896 16.3201C13.2996 16.6101 13.2996 17.0901 13.5896 17.3801C13.7396 17.5301 13.9296 17.6001 14.1196 17.6001C14.3096 17.6001 14.4996 17.5301 14.6496 17.3801L17.6896 14.3401C17.7596 14.2701 17.8096 14.1901 17.8496 14.1001C17.9196 13.9201 17.9196 13.7101 17.8496 13.5301Z",
    fill: "#F37846"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15016 10.4701C6.23016 10.6501 6.37016 10.8001 6.56016 10.8801C6.65016 10.9201 6.75016 10.9401 6.85016 10.9401H17.1602C17.5702 10.9401 17.9102 10.6001 17.9102 10.1901C17.9102 9.78009 17.5702 9.44009 17.1602 9.44009H8.66016L10.4202 7.68009C10.7102 7.39009 10.7102 6.91009 10.4202 6.62009C10.1302 6.33009 9.65016 6.33009 9.36016 6.62009L6.32016 9.65009C6.25016 9.72009 6.19016 9.81009 6.15016 9.90009C6.08016 10.0801 6.08016 10.2901 6.15016 10.4701Z",
    fill: "#F37846"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.ddd556b7feaa4dfd046adf4d79cf98f9.svg";
export { ForwardRef as ReactComponent };